"use client"

import { Box, Flex } from "@chakra-ui/react";
import BaseMenu from "./header/BaseMenu"
import React, { useState, useEffect } from 'react';

export default function Header({ categories, cities, hasCity }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const h = {
    base: '55px',
    md: '90px',
  }

  const height = { base: h.base, md: scrolled === true ? h.base : h.md };
  const bgColor = scrolled === true ? 'gray.500/95' : 'gray.500';

  return (
    <Box position="relative">
      <Flex position="fixed" zIndex="999999" alignItems="center" transition="all .5s ease-in-out" w="100%" h={height} bgColor={bgColor} color="white">
        <BaseMenu categories={categories} scrolled={scrolled} cities={cities} hasCity={hasCity} />
      </Flex>

      <Box w="100%" h={height} ></Box>
    </Box>
  )
}
